exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unit4a-3 .intro ol{font-weight:700;border-bottom:3px solid #fcf390;padding-bottom:45px}.unit4a-3 .unit-header+.exercise{padding-bottom:150px}.unit4a-3 .exercise .exercise-wrapper.exercise-wrapper_topoffset{padding-top:120px}.unit4a-3 .simplest__structure-block{color:#050e61}.unit4a-3 .scq-diagram-dnd-wrapper .submit{position:static}.note__table{color:#000}.note__table-title{font-size:34px;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/modules/courses/4/4c2/practiceInSeeing3/practiceInSeeing3.scss
// module id = 776
// module chunks = 0